import { zoneMapColors } from 'common/enums/ColorEnum';

class ColorUtil {
    static shadeRGBColor(color, percent) {
        var rgbValues = color.split(',');
        var t = percent < 0 ? 0 : 255;
        var absPercent = percent < 0 ? percent * -1 : percent;
        var R = parseInt(rgbValues[0].slice(4));
        var G = parseInt(rgbValues[1]);
        var B = parseInt(rgbValues[2]);
        return (
            'rgb(' +
            (Math.round((t - R) * absPercent) + R) +
            ',' +
            (Math.round((t - G) * absPercent) + G) +
            ',' +
            (Math.round((t - B) * absPercent) + B) +
            ')'
        );
    }
    static shadeHexColor(color, percent) {
        var integerColorValue = parseInt(color.slice(1), 16);
        var t = percent < 0 ? 0 : 255;
        var absPercent = percent < 0 ? percent * -1 : percent;
        var R = integerColorValue >> 16;
        var G = (integerColorValue >> 8) & 0x00ff;
        var B = integerColorValue & 0x0000ff;
        return (
            '#' +
            (
                0x1000000 +
                (Math.round((t - R) * absPercent) + R) * 0x10000 +
                (Math.round((t - G) * absPercent) + G) * 0x100 +
                (Math.round((t - B) * absPercent) + B)
            )
                .toString(16)
                .slice(1)
        );
    }

    static shadeColor(color, percent) {
        if (color.length > 7) {
            return this.shadeRGBColor(color, percent);
        }
        return this.shadeHexColor(color, percent);
    }

    static hexToRgb({ color }) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(color)) {
            c = color.substring(1).split('');
            if (c.length === 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join(''); //eslint-disable-line prefer-template
            const [red, green, blue] = [
                (c >> 16) & 255,
                (c >> 8) & 255,
                c & 255
            ];
            return {
                red,
                green,
                blue
            };
        } else {
            throw new Error('Bad Hex');
        }
    }
    static hexToRgbAString({ color, opacity = 1 }) {
        const { red, green, blue } = ColorUtil.hexToRgb({ color });
        return `rgba(${red},${green},${blue},${opacity})`;
    }

    static getZoneMapsColorName(colorCode, colors = zoneMapColors) {
        const [filteredColor] = Object.values(colors).filter(
            color => color.code === colorCode
        );
        return filteredColor ? filteredColor.name : null;
    }

    static isLight(hex) {
        const { red, green, blue } = ColorUtil.hexToRgb(hex);
        // Compute the perceptive luminance, keeping in mind that the human eye favors green.

        const luminance =
            1 - (0.299 * red + 0.587 * green + 0.3114 * blue) / 255;

        return luminance < 0.26;
    }
}

export default ColorUtil;
